class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);
    this.addedProductIsPreorder = false; // refers only to the product that was just added, not the entire cart - the cart contents are checked ijn liquid
    this.cartItems = JSON.parse(this.querySelector('#cart_items_notification').textContent);


    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener('transitionend', () => {
      this.notification.focus();
      trapFocus(this.notification);
    }, { once: true });

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');

    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
    let itemIds = [];

    parsedState.items.forEach((item) => {
      itemIds.push(`cart-notification-product-${item.id}`);
    });

    let cartNotificationsAll = document.createElement('div');
    cartNotificationsAll.innerHTML = parsedState.sections['cart-notification-product'];

    cartNotificationsAll.querySelectorAll('.cart-notification-product').forEach((cartNotificationProduct) => {
      if(!itemIds.includes(cartNotificationProduct.id)) {
        cartNotificationProduct.remove();
      }
    });

    document.getElementById('cart-notification-product').innerHTML = cartNotificationsAll.innerHTML;
    document.getElementById('cart-notification-button').innerHTML = parsedState.sections['cart-notification-button'];
    document.getElementById('cart-icon-bubble').innerHTML = parsedState.sections['cart-icon-bubble'];

    if (this.header) {
      this.header.reveal();
    }

    this.open();
    this.checkLacesAndStopper();
    this.checkPreorder();
    this.handleNotifications(parsedState);
  }

  handleNotifications(parsedState) {
  // find out if there are laces, b- or c-ware in cart or added to cart or if group discount is activated
    this.addedProductIsLaces = window.location.pathname.includes('elastiksenkel') || window.location.pathname.includes('elastic-laces');
    this.addedProductIsBware = document.querySelector('.product.is-bware');
    this.cartHasBware = this.cartItems.filter(item => item.title.includes('B_')).length > 0;
    this.addedProductIsCware = document.querySelector('.product.is-cware');
    this.cartHasCware = this.cartItems.filter(item => item.title.includes('C_')).length > 0;
    this.addedProductActivatesGroupDiscount = parsedState.items.filter(item => item?.discounts[0]?.title === 'Group Discount').length > 0;
    this.cartHasGroupDiscount = this.cartItems.filter(item => item.line_level_discount_allocations[0]?.discount_application.title === 'Group Discount').length > 0;

  // show error message in notification popup on pdp and disable express checkout if b-ware, c-ware or group-discount is added or in cart
    if (this.addedProductIsBware || this.cartHasBware || this.addedProductIsCware || this.cartHasCware || this.addedProductActivatesGroupDiscount || this.cartHasGroupDiscount) {
      document.querySelector('#cart-notification-form > button').addEventListener('click', (e) => {
        e.preventDefault();
        if (document.querySelector('.notification__note__wrapper')) {
          document.querySelector('.notification__note__wrapper').classList.add('is-shown');
        }
      });
    }
  }

  checkPreorder() {
    // if there already are any preorder items in the cart
    // this is a very ugly way of doing this, but it seems that a boolean value passed from liquid is a string in JS
    const cartHasPreorder = this.querySelector('#cart_items_notification').dataset.carthaspreorder === 'true';
    if (this.addedProductIsPreorder || cartHasPreorder) {
      document.querySelector('#cart-notification-form > button ').addEventListener('click', (e) => {
        e.preventDefault();
        if (document.querySelector('.notification__note__wrapper')) {
          document.querySelector('.notification__note__wrapper').classList.add('is-shown');
        }
      });
    }
  }

   // check in cart the laces and stopper and compare them
  checkLacesAndStopper() {
    document.querySelector('#cart-notification-form > button ').addEventListener('click', (e) => {
      let laceItems = 0;
      let clipItems = 0;
      const translationSenkel = Shopify.locale === 'de' ? 'Elastiksenkel' : 'Elastic Laces';
      for (let i = 0; i < this.cartItems.length; i++) {
        const itemText = this.cartItems[i].product_title;
        if (itemText.includes(translationSenkel)) {
          laceItems = this.cartItems[i].quantity;
        } else if (itemText.includes('clips')) {
          clipItems = this.cartItems[i].quantity;
        }
      }

      // show error messages if not enough or too many clips
      if (laceItems === clipItems) {
        if (document.querySelector('.notification__note__wrapper')) {
          document.querySelector('.notification__note__wrapper').classList.remove('is-shown');
        }
        return false;
      } else  {
        e.preventDefault();
        document.querySelector('.notification__note__wrapper').classList.add('is-shown');
        return false;
      }
    })
  }

  addEndClips() {
    return [
      {
        id: 'cart-notification-product',
        selector: `#cart-notification-product-${this.productId}`,
      },
      {
        id: 'cart-notification-product-endclips',
        selector: `#cart-notification-product-${this.endClipId}`,
      },
      {
        id: 'cart-notification-button'
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `#cart-notification-product-${this.productId}`,
      },
      {
        id: 'cart-notification-button'
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
